var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-177.14 -177.14 649.52 649.52",
    xmlSpace: "preserve",
    width: "198px",
    height: "198px",
    stroke: "#000000",
    strokeWidth: 2.066666,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -177.14,
    y: -177.14,
    width: 649.52,
    height: 649.52,
    rx: 324.76,
    fill: "#DA4A5A",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.952,184.19v11.048h71.429v-47.619h-45.31L80.952,184.19z M142.857,157.143v28.571h-51.29l20.41-28.571H142.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.143,147.619v47.619h71.429V184.19l-26.119-36.571H157.143z M166.667,185.714v-28.571h30.881l20.41,28.571H166.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.348,185.857l-19.033-4.762c-4.795-1.214-7.567-3.086-11.581-7.671l-23.933-33.5 c-6.138-7.852-13.171-11.352-22.8-11.352h-90.476c-9.633,0-16.667,3.5-22.924,11.519l-23.529,32.976 c-4.276,4.924-7.538,7.162-11.476,7.952l-28.757,4.795C9.181,188.657,0,200.1,0,214.286v33.333 c0,10.324,8.724,19.048,19.048,19.048h14.667c2.324,16.124,16.195,28.571,32.952,28.571h228.571v-9.524h-43.386 c5.114-5.005,8.6-11.638,9.671-19.048h19.429c11.805,0,14.286-7.771,14.286-14.286v-42.857 C295.238,197.719,285.605,187.252,277.348,185.857z M66.667,285.715c-13.129,0-23.81-10.682-23.81-23.81 c0-13.129,10.681-23.81,23.81-23.81c13.129,0,23.81,10.681,23.81,23.81C90.477,275.034,79.796,285.715,66.667,285.715z M89.948,285.714c5.114-5.005,8.6-11.638,9.671-19.048h96c1.067,7.41,4.552,14.043,9.671,19.048H89.948z M228.571,285.714 c-13.129,0-23.81-10.681-23.81-23.81c0-13.129,10.681-23.81,23.81-23.81c13.129,0,23.81,10.681,23.81,23.81 C252.381,275.033,241.7,285.714,228.571,285.714z M285.714,252.381L285.714,252.381c0,4.09-0.667,4.762-4.762,4.762h-19.429 c-2.324-16.124-16.195-28.571-32.952-28.571c-16.757,0-30.629,12.448-32.952,28.571h-96 c-2.324-16.124-16.195-28.571-32.952-28.571c-16.757,0-30.629,12.448-32.952,28.571H19.048c-5.071,0-9.524-4.452-9.524-9.524 v-23.81h9.524v9.524h9.524v-9.524c0-6.143-3.381-9.524-9.524-9.524H9.524c0-11.781,7.881-17.614,15.071-19.114l28.724-4.79 c6.214-1.248,11.281-4.557,17.224-11.424l23.686-33.171c4.381-5.605,8.529-7.69,15.295-7.69H200 c6.762,0,10.91,2.086,15.171,7.529l24.09,33.69c4.671,5.371,9.095,9.086,16.724,11.014l19.4,4.838 c4.067,0.7,10.329,7.171,10.329,14.357V252.381z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.095,
    y: 204.762,
    width: 14.286,
    height: 9.524
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.667,247.619c-7.876,0-14.286,6.41-14.286,14.286c0,7.876,6.41,14.286,14.286,14.286 c7.876,0,14.286-6.41,14.286-14.286C80.952,254.029,74.543,247.619,66.667,247.619z M66.667,266.667 c-2.624,0-4.762-2.133-4.762-4.762c0-2.629,2.138-4.762,4.762-4.762c2.624,0,4.762,2.133,4.762,4.762 C71.429,264.534,69.29,266.667,66.667,266.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.571,247.619c-7.876,0-14.286,6.41-14.286,14.286c0,7.876,6.41,14.286,14.286,14.286 c7.876,0,14.286-6.41,14.286-14.286C242.857,254.029,236.448,247.619,228.571,247.619z M228.571,266.667 c-2.624,0-4.762-2.133-4.762-4.762c0-2.629,2.138-4.762,4.762-4.762c2.624,0,4.762,2.133,4.762,4.762 C233.333,264.534,231.195,266.667,228.571,266.667z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 285.714,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.762,
    y: 285.714,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.905,
    y: 47.619,
    width: 9.524,
    height: 71.429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.571,
    y: 47.619,
    width: 9.524,
    height: 90.476
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.571,
    y: 47.619,
    width: 9.524,
    height: 90.476
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.905,
    y: 47.619,
    width: 9.524,
    height: 90.476
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.238,
    y: 47.619,
    width: 9.524,
    height: 71.429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.571,
    y: 66.667,
    width: 9.524,
    height: 52.381
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.905,
    y: 47.619,
    width: 9.524,
    height: 52.381
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.238,
    y: 47.619,
    width: 9.524,
    height: 71.429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.81,14.286h-59.524V0h-9.524v14.286H90.476V0h-9.524v14.286H21.429C9.614,14.286,0,23.9,0,35.714v7.143h295.238 v-7.143C295.238,23.9,285.624,14.286,273.81,14.286z M10.519,33.333c1.838-4.762,6.038-9.524,10.91-9.524H273.81 c4.871,0,9.071,4.762,10.91,9.524H10.519z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.905,
    y: 147.619,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.905,
    y: 147.619,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.571,
    y: 147.619,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.571,
    y: 166.667,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.905,
    y: 166.667,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.905,
    y: 109.524,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.905,
    y: 128.571,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    y: 171.429,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.714,
    y: 171.429,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.571,
    y: 47.619,
    width: 9.524,
    height: 9.524
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCarFull);
export default __webpack_public_path__ + "static/media/icn_car_full.e011218879e6f1232ec77de35abb3a8e.svg";
export { ForwardRef as ReactComponent };